// extracted by mini-css-extract-plugin
module.exports = {"link":"CoingeckoLink_link___zbaa","symbol":"CoingeckoLink_symbol__xtWe_","brand":"CoingeckoLink_brand__PkHCK"};